<template>
  <div>
      <base-page-header :title="$t('environmental-management.title')" title-class="budget-title"></base-page-header>

      <v-row class="bg-gray">
        <v-col cols="12" class="grafic">
          <v-row>
            <v-col cols="12" sm="12" class="text-center text-md-left">
              <base-button color="white" @click="filterAction('all')" :class="acao == 'all'? 'active': ''" class="mr-3 mb-3" height="50">{{ $t('everything') }}</base-button>

              <base-button color="white" @click="filterAction('day')" :class="acao == 'day'? 'active': ''" class="mr-3 mb-3" height="50">{{$t('environmental-management.today')}}</base-button>

              <base-button color="white" @click="filterAction('week')" :class="acao == 'week'? 'active': ''" class="mr-3 mb-3" height="50">{{$t('environmental-management.acc-week')}}</base-button>

              <base-button color="white" @click="filterAction('month')" :class="acao == 'month'? 'active': ''" class="mr-3 mb-3" height="50">{{$t('environmental-management.acc-month')}}</base-button>

              <base-button color="#bdbdbd" class="mr-3 mb-3 xlsbtn" :height='50' @click="handleExport" style="float: right;" v-if="userState.isAdminSILiAmb">
                {{ $t('b2b.environmental-export-text2') }}
                <img class="ml-2" src="/images/_SVGs/environmental/file-xlsx-white.svg" onload="SVGInject(this)" height="30"/>
              </base-button>
            </v-col>

            <!-- <v-col cols="12" sm="2" v-if="Object.keys(mainRoutes).length > 1">
              <v-select
                :items="Object.keys(mainRoutes).length > 1 ? mainRoutes.map(el => ({text: el.name, value: +el.mainRouteId})): []"
                :label="$t('environmental-management.route-name')"
                v-model="selectRoute"
                solo
                hide-details
                :menu-props="{ top: false, offsetY: true }"
              ></v-select>
            </v-col> -->
          </v-row>

          <div>
            <h4>{{ $t('b2b.environmental.kpis.title4') }}</h4>
          </div>
          <!-- <Accumulated :items="indicators"/> -->

          <v-row class="d-flex flex-row main-row">
            <v-col cols="12" sm="3" class="dv-nr-clients p-0 d-flex flex-row">
              <v-col cols="3" class="dv-nr-clients-div1 ml-2">
                <div>
                  <span class="spannumbers">{{totalClients}}</span>
                </div>
                <span class="spantexts2">{{ $t('b2b.environmental.kpis.title1') }}</span>
              </v-col>
              <v-col cols="8" class="table_chart" v-if="topClients && topClients.length">
                <table>
                  <thead class="tablehead">
                    <tr>
                      <th>
                        {{ $t('b2b.environmental.kpis.title2') + ' ' + topClients.length + ' ' + $t('b2b.environmental.kpis.title5')}}
                      </th>
                    </tr>
                  </thead>
                  <tr v-for="item in topClients">
                    <td :class="item.isSelected ? 'activecls' : ''" @click="handleClickTableRow(item)">{{ item.display }}</td>
                  </tr>
                </table>
              </v-col>
              <v-col class="dv-nr-clients-div2"></v-col>
            </v-col>
            <v-col cols="12" sm="5">
              <v-chart
                :options="option"
                ref="graphic"
                class="graphic-resize-env"
                @legendselectchanged="handleClickLegend"
              />
            </v-col>
            <v-col cols="12" sm="4" class="div-numbers flex-col" v-if="kpiResidues[0]">
              <div class="dv-nrb-div1">
              </div>
              <div class="div-numbers" style="width: 100%;">
                <div class="dv-nrb-div1 mr-7">
                </div>
                <v-row class="dv-nrb-div2" v-if="kpiResidues[0]">
                  <v-col v-for="(item, index) in kpiResidues" :key="index" :cols="kpiResidues.length > 1 ? 4 : 12" :class="kpiResidues.length > 1 ? 'd-flex justify-center p-0' : 'd-flex p-0 ml-5'">
                    <div class="d-flex flex-column align-items-center" >
                      <span class="spannumbers" style="font-size: 25px !important">{{ item.formatted }}</span>
                      <span class="spantexts" style="word-wrap: break-word; overflow: hidden;">{{ item.name }}</span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>


          <div class="div-small-screens">
            <div class="p-0 d-flex flex-row">
              <div class="d-flex flex-row justify-center align-center" style="text-align: center;" v-for="(item, index) in kpiResidues" :key="index">
                <span class="spannumbers ml-4">{{ item.value }} <span class="spantexts">{{ item.name }}</span></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="mt-5">
          <div class="row">
              <div v-for="module in listMenu" :key="module.route"  style="position: relative;     display: contents;">
                  <div class="col col-12 col-sm-6 col-md-4 col-xl-3"  v-if="module.isActive">
                    <template>
                        <router-link
                          v-if="!module.isBlock"
                          :to="{ name: module.route }"
                        >
                            <Menu :config-card="module" :style="module.isBlock ? 'opacity: 0.5' : ''" >
                            </Menu>

                            <div class="notify" v-if="module.notify">{{module.notify}}</div>
                        </router-link>
                    </template>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { EnvironmentalDocServicesGetSILiAmbContainerTypes } from '@services/b2b/environmental-management/DocumentationService';
import { ExportSILiAmbMetrics } from '@services/b2b/environmental-management/DocumentationService';
import { GetMainRouter, GetIndicador } from '@services/b2b/environmental-management/EgarService';
import Accumulated from '@components/b2b/environmental-management/Accumulated';
import Menu from '@components/b2b/environmental-management/Menu';
import moment from 'moment';
import BaseButton from "@components/shared/widgets/BaseButton.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";

export default {
  components:{
      BasePageHeader,
      BaseButton,
    Accumulated,
    Menu
  },
  data() {
    return {
      select: ['Nome da Rota'],

      indicators: [{
        name: this.$t('environmental-management.indicators.collections'),
        value: 0,
        icon: '/images/_SVGs/environmental/recolhas.svg'
      },
      {
        name: this.$t('environmental-management.indicators.battery'),
        value: 0,
        icon: '/images/_SVGs/environmental/bateria.svg'
      },
      {
        name: this.$t('environmental-management.indicators.oil-filter'),
        value: 0,
        icon: '/images/_SVGs/environmental/fluidos.svg'
      },
      {
        name: this.$t('environmental-management.indicators.ferrous-metals'),
        value: 0,
        icon: '/images/_SVGs/environmental/pneus.svg'
      }],
      listMenu:[
        {
            id: 6,
            icon: '/images/_SVGs/environmental/cards/residuos.svg',
            title: '',
            subtitle: this.$t('environmental-management.list-menu.subtitle1'),
            description: '',
            route: 'environmentalManagementScheduling',
            isActive: true,
            isBlock: true,
        },
        {
            id: 8,
            icon: '/images/_SVGs/environmental/cards/rotas.svg',
            title: '',
            subtitle: this.$t('environmental-management.list-menu.subtitle2'),
            description: '',
            route: 'environmentalManagementRouteManagement',
            isActive: true,
            isBlock: true,
        },
        {
            id: 7,
            icon: '/images/_SVGs/environmental/cards/egar.svg',
            title: '',
            subtitle: this.$t('environmental-management.list-menu.subtitle3'),
            description: '',
            route: 'environmentalManagementEGAR',
            isActive: true,
            isBlock: true,
        },
        {
            id: 5,
            icon: '/images/_SVGs/environmental/cards/documentacao.svg',
            title: '',
            subtitle: this.$t('environmental-management.list-menu.subtitle4'),
            description: '',
            route: 'environmentalManagementDocuments',
            notify: 0,
            isActive: true,
            isBlock: true,
        },
        {
            id: 1,
            icon: '/images/_SVGs/environmental/cards/valorizacao_vfv.svg',
            title: '',
            subtitle: this.$t('environmental-management.list-menu.subtitle5'),
            description: '',
            route: '',
            isBlock: true,
            isActive: true
        },

      ],
      filter: {
        dateFrom: '',
        dateTo: '',
        mainRouteId: '',
      },
      mainRoutes: [],
      acao: 'all',
      selectRoute: null,
      option: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // left: '',
          // top: 'middle',
          bottom: '8%',
          orient: 'horizontal',
          width: '100%',
          textStyle: {
            fontSize: 10
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '40%'],
            // roseType: 'area',
            label: {
              show: true,
              position: 'outside',
              fontSize: 12,
              formatter: '{b}\n{d}%',
              color: "#000",
              distanceToLabelLine: 0,
              bleedMargin: 0
              // formatter: '{b}\n{c} ({d}%)',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold'
              },
              labelLine: {
                show: true
              }
            },
            labelLine: {
              show: true
            },
            data: []
          }
        ],
        title: [
          {
            text: "",
          },
          {
            text: this.$t('b2b.environmental.kpis.title3'),
            textAlign: 'center',
            left: '49%',
            top: '40%',
            textStyle: {
              fontSize: 16,
              fontWeight: 20,
              color: this.$vuetify.theme.themes.light.primary
            }
          },
          {
            text: '0',
            textAlign: 'center',
            left: '49%',
            top: '50%',
            textStyle: {
              fontSize: 31,
              fontWeight: 'bold ',
              color: this.$vuetify.theme.themes.light.primary
            }
          }
        ],
      },
      tableData: [
        { display: 'Cliente 1', value: 1 },
        { display: 'Cliente 2', value: 2 },
        { display: 'Cliente 3', value: 3 },
        { display: 'Cliente 4', value: 4 },
        { display: 'Cliente 5', value: 5 }
      ],
      tableDataHeaders: [
        {
          title: "Top 5 Clientes",
        }
      ],
      ascending: false,
      analysisData: [
        {value: '15', name: 'Resíduo 1 Nome Grande (Kg)'},
        {value: '8', name: 'Resíduo 2 (Kg)'},
        {value: '37', name: 'Resíduo 3 (Kg)'},
        {value: '24', name: 'Resíduo 4 (Kg)'},
        {value: '31', name: 'Resíduo 5 Grande Nome (Kg)'},
        {value: '64', name: 'Resíduo 6 (Kg)'},
      ],
      kpiContainers: [],
      kpiResidues: [],
      topClients: [],
      totalClients: 0,
      totalKPIContainers: 0,
      containerTypesItems: [],
      originalContainers: [],
      originalAction: '',
      firstRender: 1,
      currentContainerTypesIds: "",
      originalTopClients: [],
      originalContainerTypesIds: ""
    }
  },
  watch: {
    selectRoute: {
        handler: function(newValue, oldValue) {
          this.filter.mainRouteId = newValue;
          this.getIndicadores();
          return newValue;
        },
        immediate: false,
        deep: true,
    },
  },
  computed:{
      userState() {
          return this.$store.getters['auth/getState'];
      },
      groupedAnalysisData() {
        const grouped = [];
        for (let i = 0; i < this.analysisData.length; i += 3) {
          grouped.push(this.analysisData.slice(i, i + 3));
        }
        return grouped;
      }
  },
  methods: {
    async filterAction(name) {
      this.acao = name;

      let startOfWeek = moment().startOf('isoWeek');
      let endOfWeek = moment().endOf('isoWeek');

      let startOfMonth = moment().startOf('month');
      let endOfMonth = moment().endOf('month');

      if(name == 'day'){
        this.filter.dateFrom = moment().format('YYYY-MM-DD')
        this.filter.dateTo = ''
      }else if(name == 'week'){
        this.filter.dateFrom = startOfWeek.format('YYYY-MM-DD')
        this.filter.dateTo = endOfWeek.format('YYYY-MM-DD')
      } else if(name == 'all') {
        this.filter.dateFrom = "";
        this.filter.dateTo = "";
      } else {
        this.filter.dateFrom = startOfMonth.format('YYYY-MM-DD')
        this.filter.dateTo = endOfMonth.format('YYYY-MM-DD')
      }

      await this.clearGraphData();
      await this.getIndicadores();
    },
    async clearGraphData() {
      this.kpiContainers = [],
      this.kpiResidues = [],
      this.topClients = [],
      this.totalClients = 0,
      this.totalKPIContainers = 0,
      this.originalContainers = [],
      this.originalAction = '',
      this.currentContainerTypesIds = "",
      this.originalTopClients = [],

      await this.clearOptionGraphData();
    },
    async clearOptionGraphData() {
      this.option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          // left: '',
          // top: 'middle',
          bottom: '8%',
          orient: 'horizontal',
          width: '100%',
          textStyle: {
            fontSize: 10
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['30%', '40%'],
            // roseType: 'area',
            label: {
              show: true,
              position: 'outside',
              fontSize: 12,
              formatter: '{b}\n{d}%',
              color: "#000",
              distanceToLabelLine: 0,
              bleedMargin: 0
              // formatter: '{b}\n{c} ({d}%)',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 12,
                fontWeight: 'bold'
              },
              labelLine: {
                show: true
              }
            },
            labelLine: {
              show: true
            },
            data: []
          }
        ],
        title: [
          {
            text: "",
          },
          {
            text: this.$t('b2b.environmental.kpis.title3'),
            textAlign: 'center',
            left: '49%',
            top: '40%',
            textStyle: {
              fontSize: 16,
              fontWeight: 20,
              color: this.$vuetify.theme.themes.light.primary
            }
          },
          {
            text: '0',
            textAlign: 'center',
            left: '49%',
            top: '50%',
            textStyle: {
              fontSize: 31,
              fontWeight: 'bold ',
              color: this.$vuetify.theme.themes.light.primary
            }
          }
        ],
      }
    },
    async getSILiAmbContainerTypes() {
      this.$store.commit('loadings/setStateLoadingTemplate', true);
      await EnvironmentalDocServicesGetSILiAmbContainerTypes()
        .then(response => {
          if(response.data.result) {
            response.data.result.forEach(recipe => {
              let newRecipe = {
                ...recipe,
                text: recipe.description,
                value: recipe.containerTypeId
              }
              this.containerTypesItems.push(newRecipe);
            })
          } else {
            this.containerTypesItems = [];
          }
        })
        .catch(error => {
            this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
            throw new Error('error EnvironmentalDocServicesGetSILiAmbContainerTypes', error);
        })
        .finally(() => {
            this.$store.commit('loadings/setStateLoadingTemplate', false);
        })
    },
    async getIndicadores(containerTypeIds, establishmentIdFilter) {
      this.$store.commit('loadings/setStateLoadingTemplate', true);
      let body = {
        dateFrom: this.filter.dateFrom,
        dateTo: this.filter.dateTo
      }
      if(containerTypeIds) {
        this.currentContainerTypesIds = containerTypeIds;
        body['containerTypeIds'] = containerTypeIds
      }
      if(establishmentIdFilter) {
        body['establishmentId'] = establishmentIdFilter;
      }

      return await GetIndicador(body)
        .then(response => {
          this.kpiResidues = [];
          this.topClients = [];
          this.option.series[0].data = [];
          this.kpiContainers = response.data.result.kpiContainers;
          this.totalClients = this.$options.filters.numberPointFilter(+response.data.result.totalClients);
          this.totalKPIContaines = response.data.result.totalKPIContaines;
          this.option.title[2].text = String(this.$options.filters.numberPointFilter(+response.data.result.totalKPIContainers));

          if(response.data.result.topClients.length) {
            response.data.result.topClients.forEach(c => {
              let newClient = {
                ...c,
                entityId: c.name,
                isSelected: establishmentIdFilter ? c.name == establishmentIdFilter : false
              };
              this.topClients.push(newClient);
            })
          }

          if(response.data.result.kpiContainers.length) {
            response.data.result.kpiContainers.forEach(e => {
              let newData = {
                ...e,
                name: e.display
              }
              this.option.series[0].data.push(newData);
            })
          }

          if(response.data.result.kpiResidues.length) {
            response.data.result.kpiResidues.forEach((r, index) => {
              let newResidue = {
                ...r,
                formatted: this.$options.filters.numberPointFilter(+r.value),
                apiOrder: index
              }
              this.kpiResidues.push(newResidue);
            })
          }

          this.option.series[0].data.sort((a, b) => Number(b.value) - Number(a.value));
          this.kpiContainers.sort((a, b) => Number(b.value) - Number(a.value));
        })
        .catch(error => {
            throw new Error('error to get list egar values', error);
        })
        .finally(() => {
            this.$store.commit('loadings/setStateLoadingTemplate', false);
        })
    },
    getMainRoute(){
      this.$store.commit('loadings/setStateLoadingTemplate', true);
      return GetMainRouter(this.userState.isAdminSILiAmb)
          .then(response => {
            this.mainRoutes = response.data
            if (Object.keys(this.mainRoutes).length == 1) {
              this.filter.mainRouteId = this.mainRoutes[0].mainRouteId
            }
          })
          .catch(error => {
              throw new Error('error to get list egar values', error);
          })
          .finally(() => {
              this.getIndicadores();
              this.getSILiAmbContainerTypes();
              //this.$store.commit('loadings/setStateLoadingTemplate', false);
          })
    },
    handleClickToOrder() {
      if (this.ascending) {
          this.topClients = this.topClients.sort((a, b) => a.value - b.value);
      } else {
        this.topClients = this.topClients.sort((a, b) => b.value - a.value);
      }
      this.ascending = !this.ascending;
    },
    handleExport() {
        this.$store.commit('loadings/setStateLoadingTemplate', true);

        const params = {
            dateFrom: this.filter.dateFrom,
            dateTo: this.filter.dateTo
        }

        ExportSILiAmbMetrics(params)
          .then(response => {
              let blob = new Blob([response.data], {
                  type: "application/vnd.ms-excel"
              });

              let url = window.URL.createObjectURL(blob);

              const link = document.createElement('a')
              link.href = url
              var timeInMs = new Date().toISOString().slice(0, 10)
              link.setAttribute('download', this.$t('b2b.environmental-export-text') + timeInMs + ".xlsx")
              document.body.appendChild(link)
              link.click()
          })
          .catch(error => {
              this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
              throw new Error(this.$t('backoffice.entity-management.messages.export-error'), error);
          })
          .finally(() => {
              this.$store.commit('loadings/setStateLoadingTemplate', false);
          })
    },
    handleClickLegend(params) {
      const filteredSelected = Object.fromEntries(
        Object.entries(params.selected).filter(([key, value]) => value === true)
      );

      const filteredItems = this.containerTypesItems.filter(item => filteredSelected.hasOwnProperty(item.text));
      const idsFilter = filteredItems.map(item => item.containerTypeId).join(',');
      const findSelected = this.topClients.find(c => c.isSelected == true);

      if(filteredItems.length == this.kpiContainers.length) {
        if(findSelected) {
          this.currentContainerTypesIds = "";
          this.getIndicadores("", findSelected.entityId)
        } else {
          this.currentContainerTypesIds = "";
          this.getIndicadores("");
        }
      } else if(!filteredItems || filteredItems.length == 0) {
        if(findSelected) {
          this.currentContainerTypesIds = "-1";
          this.getIndicadores("-1", findSelected.entityId)
        } else {
          this.currentContainerTypesIds = "-1";
          this.getIndicadores("-1");
        }
      } else {
        if(findSelected) {
          this.getIndicadores(idsFilter, findSelected.entityId)
        } else {
          this.getIndicadores(idsFilter)
        }
      }
    },
    handleClickTableRow(tableRow) {
      if(tableRow.isSelected) {
        this.getIndicadores(this.currentContainerTypesIds)
      } else {
        this.getIndicadores(this.currentContainerTypesIds, tableRow.entityId)
      }
    },
    myEventHandler(e) {
      let myChart = this.$refs.graphic;
      if(myChart) {
        myChart.resize();
      }
    }
  },
  created() {
    this.userState.modules.filter(el => {
      if(el.route == '/environmental'){
        if(el.subModules) {
          el.subModules.filter(s => {
            this.listMenu.filter(list => {
              if(s.subModuleId == list.id){
                list.isActive = true
                list.subtitle = s.subModuleName,
                list.isBlock = false;
              }
            })

          })
        }
      }
      else if(el.routeSidebar == '/environmental'){
        if(el.subModules){
          el.subModules.filter(s => {
            this.listMenu.filter(list => {
              if(s.subModuleId == list.id){
                list.isActive = true
                list.subtitle = s.subModuleName,
                list.isBlock = false;
              }
            })

          })
        }
      }
    })

    window.addEventListener("resize", this.myEventHandler);

    this.getMainRoute();
    // this.filter.dateFrom = moment().format('YYYY-MM-DD');
  },
}
</script>

<style lang="scss">
@import '@sass/_variables.scss';
  .bg-gray{
    background-color: $grey-light;

    .grafic{
      button{
        border-radius: 10px;
      }
      .active {
        background-color: var(--v-primary-base) !important;
        color: #ffffff;
      }
    }
  }

.circle{
    border-radius: 50%;
    width: 50px;
}

.notify {
    position: absolute;
    right: 0;
    top: 0;
    background: red;
    width: 20px;
    height: 20px;
    text-align: center;
    justify-content: center;
    align-items: center;
    display: flex;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
}

.table_chart {
  align-content: center;
  max-height: 320px;
  overflow-y: auto;
  margin: 0;
  padding: 0px;
  padding-left: 16px;

  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    font-size: 12px;

    @media (max-width: 300px) {
      margin-left: 30px;
    }
  }
  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  td {
    cursor: pointer;
    &:hover {
      background-color: rgb(189, 189, 189) !important;
      color: white !important;
    }

  }
  .activecls {
    background-color: rgb(189, 189, 189) !important;
    color: white !important;
  }

  th {
    background-color: var(--v-primary-base);
    color: white;

    span {
      cursor: pointer;
    }

    svg {
      path {
        fill: white;
      }
    }
  }

  .tablehead {
    position: sticky;
    top: 0;
  }
}

.dv-nr-clients {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  flex-direction: row;

  .dv-nr-clients-div1 {
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-left: -15px;

    @media (max-width: 1025px) {
      display: none;
    }

    @media (min-width: 1441px) {
      margin-left: 40px;
    }
  }

  .dv-nr-clients-div2 {
    height: 50%;
    border-right: solid 3px var(--v-primary-base);
    @media (max-width: 1025px) {
      display: none;
    }
  }
}

.graphic-resize-env {
  display: flex;
  justify-content: center;
  width: 100% !important;
}

.div-numbers {
  padding: 0px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  margin-left: -16px;
  @media (max-width: 1025px) {
    display: none;
  }
}

.dv-nrb-div1 {
  height: 50%;
  border-right: solid 3px var(--v-primary-base);
}

.dv-nrb-div2 {
  margin-left: 30px;
  display: flex;
}

.spannumbers {
  color: var(--v-primary-base);
  font-weight: bold;
  font-size: 34px;
}

.spantexts {
  color: black;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  text-align: center;
  /* width: 122px; */
}

.spantexts2 {
  color: black;
  font-weight: bold;
  font-size: 12px;
  display: flex;
  flex-direction: row;
}

.div-small-screens {
  display: none;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 1025px) {
    display: flex;
  }
}

.margincls {
  margin-left: -20px;
}

/* Estilos gerais para a coluna */
.custom-col {
    padding: 0;
    display: flex;
    flex-direction: row;
}

/* Tamanhos de colunas para diferentes tamanhos de tela */
.custom-col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}

.custom-col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
}

.custom-col-md-5 {
    flex: 0 0 41.6667%;
    max-width: 41.6667%;
}

.custom-col-sm-5 {
    flex: 0 0 41.6667%;
    max-width: 41.6667%;
}

/* Responsividade */
@media (min-width: 1441px) {
    .custom-col-lg-3 {
      flex: 0 0 25%;
      max-width: 25%;
    }
}

@media (max-width: 992px) {
    .custom-col-md-5 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

@media (max-width: 768px) {
    .custom-col-sm-5 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

.main-row {
  justify-content: center;
  margin-top: -56px;

  @media (min-width: 1441px) {
    justify-content: left;
  }
}

.custom-col {
  @media (min-width: 1441px) {
    margin-left: 34px;
  }
}

.xlsbtn {
  span {
    color: white;
  }
}
</style>
